// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-not-found[data-v-2932adca]{text-align:center;margin:20px 0}.search-not-found>button[data-v-2932adca]{font-size:14px;line-height:20px;color:#999;text-decoration:underline;border:0;background:transparent;outline:none;cursor:pointer}.search-not-found>button[data-v-2932adca]:hover{color:#222226}.search-not-found>button[data-v-2932adca]:disabled{color:#999;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
